import type { LocationState } from './types';

const initialState: LocationState = {
  position: null,
  denied: null,
  timeout: null,
  dismissed: false,
};

export default initialState;
